import { render, staticRenderFns } from "./ot-contract-users-table.vue?vue&type=template&id=f6ff8834&scoped=true&"
import script from "./ot-contract-users-table.vue?vue&type=script&lang=ts&"
export * from "./ot-contract-users-table.vue?vue&type=script&lang=ts&"
import style0 from "./ot-contract-users-table.vue?vue&type=style&index=0&id=f6ff8834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ff8834",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
